import React, { Component } from 'react';
import config from '../../config';

import './index.css';

class Page extends Component {
    constructor(props) {
        super(props);
        this.state = {};
    }

    render() {
        const loginUrl = `${config.endpoint}/login`;
        return (
            <div class="d-flex flex-row align-items-center" style={{height: `100vh`}}>
                <div class="container">
                    <div class="row">
                        <div class="col-md-12 text-center">
                            <div class="mb-4 lead" style={{ whiteSpace: 'pre-line' }}>{this.props.msg}</div>
                            <a href={loginUrl} class="btn btn-primary btn-lg active mybtn">再認証する</a>
                            <div class="mb-4 lead akamozi">認証後、必ず打刻してください。</div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default Page;



// WEBPACK FOOTER //
// ./src/components/error/index.js